import api from '../../../api';

// Keep legacy user endpoints for update/upload, but use new CRM profile read endpoint
const API_URL = '/api/users';
const PROFILE_READ_URL = '/crm/profile';

export async function getCurrentUserProfile() {
  try {
    // Use the new unified profile endpoint
    const res = await api.get(`${PROFILE_READ_URL}`);
    return res.data;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw error;
  }
}

export async function updateUserProfile(userData) {
  try {
    // Format data for profile update
    const payload = {
      username: userData.username,
      firstName: userData.firstName,
      lastName: userData.lastName,
      email: userData.email,
      nohp: userData.nohp,
      businessLocation: userData.businessLocation,
      address: userData.address,
      country: userData.country,
      state: userData.state,
      city: userData.city,
      postalCode: userData.postalCode
    };

    console.log('Updating user profile with payload:', payload);
    // Use the new CRM profile endpoint for updates
    const res = await api.put(`${PROFILE_READ_URL}`, payload);
    return res.data;
  } catch (error) {
    console.error('Error updating user profile:', error);
    throw error;
  }
}

export async function uploadProfilePicture(file) {
  try {
    const formData = new FormData();
    formData.append('profilePicture', file);
    
    const res = await api.post(`${API_URL}/profile/picture`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return res.data;
  } catch (error) {
    console.error('Error uploading profile picture:', error);
    throw error;
  }
}

export async function uploadSignature(file) {
  try {
    const formData = new FormData();
    formData.append('signature', file);
    
    const res = await api.post(`${API_URL}/profile/signature`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return res.data;
  } catch (error) {
    console.error('Error uploading signature:', error);
    throw error;
  }
}

export async function getUserActivities(page = 0, size = 10) {
  try {
    const res = await api.get(`${PROFILE_READ_URL}/activities?page=${page}&size=${size}`);
    return res.data;
  } catch (error) {
    console.error('Error fetching user activities:', error);
    throw error;
  }
}

